var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgThumbimg = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M3.40419 5.37402H0.615818C0.278212 5.37402 0 5.64598 0 5.98984V14.6644C0 15.0083 0.278212 15.2834 0.615818 15.2834H3.40419C3.74805 15.2834 4.02313 15.0052 4.02313 14.6644V5.98984C4.02313 5.64598 3.74492 5.37402 3.40419 5.37402Z",
  fill: "#5C6AC4"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M14.7797 8.40445H13.4512C14.1327 8.40445 14.6797 7.83552 14.6453 7.14468C14.6141 6.51636 14.0139 6.00995 13.3856 6.00995H10.8441L11.138 3.02777C11.138 2.28999 10.8334 1.62369 10.343 1.14771C9.54527 0.373396 8.57523 1.34045 8.2233 2.39501C8.06751 2.86186 7.85128 3.3245 7.57748 3.85303C6.98667 4.99089 5.88946 5.763 4.64532 5.95994C4.64532 5.96932 4.64844 5.97869 4.64844 5.9912V14.6658C4.64844 14.7221 4.63906 14.7721 4.63281 14.8252L5.02043 15.0159C5.79568 15.3941 6.64594 15.5911 7.50559 15.5911H12.4321C13.0042 15.5911 13.5262 15.2035 13.6388 14.6408C13.7951 13.8718 13.2074 13.1966 12.4665 13.1966H13.6325C14.2827 13.1966 14.8641 12.712 14.8985 12.0618C14.936 11.371 14.3859 10.8021 13.7044 10.8021H14.7172C15.3455 10.8021 15.9489 10.2957 15.9832 9.66735C16.0145 8.97651 15.4643 8.40445 14.7797 8.40445Z",
  fill: "#5C6AC4"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgThumbimg);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/thumbimg.bbb15f6b02c5018b30539987ba4d3c0f.svg";